import React from 'react';
import MaskedInput from 'react-text-mask';
import styled from 'styled-components';
import { Input as StyledInput, CssTextField } from './utilities/commonUtilities/FormElements';
import { COLOR_GREY, FONT_WEIGHT_SEMI } from './utilities/Material';
import { makeStyles } from '@material-ui/core/styles';
import { styleBreakDesktop, styleBreakMobile } from './utilities/layouts/Globals';
import { InputAdornment, useTheme } from '@material-ui/core';
import { ReactComponent as AlertTriangle } from '../resources/images/alert-triangle.svg';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    input: {
        [styleBreakMobile(theme)]: {
            width: '100%',
        },
        [styleBreakDesktop(theme)]: {
            width: theme.spacing(40.875),
        },
        '& .MuiOutlinedInput-root': {
            '&:hover': {
                '& fieldset': {
                    border: `1px solid ${theme.palette.primary.dark}`,
                },
            },
        },
    },
    alertTriangle: {
        width: theme.spacing(2),
        height: theme.spacing(2),
        marginRight: '13px',
        marginLeft: '7px',
    },
}));

const HealthCardNumberSpecificInput = styled(StyledInput)`
    font-family: ${props => props.theme.typography.fontFamily};
    font-weight: ${FONT_WEIGHT_SEMI};
    & input::placeholder {
        color: ${COLOR_GREY.light};
    }
`;

const MaskedInputWrapper = ({ isinvalid, ...props }) => {
    return <MaskedInput {...props} />;
};
const CssTextFieldWrapper = ({ isinvalid, isWatchman, ...props }) => {
    return <CssTextField {...props} />;
};

export const OhipInput = props => {
    const classes = useStyles();
    const theme = useTheme();

    const { isinvalid, isWatchman, filled, ...inputProps } = props;

    let startAdornment = isinvalid ? (
        <InputAdornment>
            <AlertTriangle stroke={theme.palette.error.main} className={classes.alertTriangle} />
        </InputAdornment>
    ) : undefined;

    const ohipMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
    const ohipPlaceholder = '####-###-###';

    if (isWatchman) {
        return (
            <MaskedInput
                className={classes.input}
                mask={ohipMask}
                placeholder={ohipPlaceholder}
                {...inputProps}
                render={(ref, inputProps) => {
                    return (
                        <CssTextFieldWrapper
                            {...inputProps}
                            inputRef={ref}
                            isWatchman={isWatchman}
                            error={!!isinvalid}
                            className={clsx(classes.input, { [classes.inputFilled]: filled })}
                            InputProps={{
                                startAdornment: startAdornment,
                            }}
                        />
                    );
                }}
            />
        );
    } else {
        return (
            <HealthCardNumberSpecificInput
                className={classes.input}
                {...inputProps}
                isinvalid={isinvalid}
                mask={ohipMask}
                placeholder={ohipPlaceholder}
                as={MaskedInputWrapper}
            />
        );
    }
};

export const NovaScotiaInput = props => {
    const classes = useStyles();
    const { isinvalid, isWatchman, filled, ...inputProps } = props;

    return (
        <HealthCardNumberSpecificInput
            className={classes.input}
            mask={[/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/]}
            {...inputProps}
            placeholder="#### ### ###"
            isinvalid={isinvalid}
            as={MaskedInputWrapper}
        />
    );
};

export const AlbertaInput = props => {
    const classes = useStyles();
    const { isinvalid, isWatchman, filled, ...inputProps } = props;

    return (
        <HealthCardNumberSpecificInput
            className={classes.input}
            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            {...inputProps}
            placeholder="#####-####"
            isinvalid={isinvalid}
            as={MaskedInputWrapper}
        />
    );
};

export const NoHealthCardSystemSelectedInput = props => {
    const classes = useStyles();
    const { isinvalid, isWatchman, filled, ...inputProps } = props;

    return <HealthCardNumberSpecificInput className={classes.input} {...inputProps} />;
};
